import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 15000 });

// ---- Content (GET) with graceful fallback handled by callers ----
export const getEpisodes = () => http.get("/episodes").then((r) => r.data);
export const getEpisode = (id) => http.get(`/episodes/${id}`).then((r) => r.data);
export const getBlog = () => http.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => http.get(`/blog/${slug}`).then((r) => r.data);
export const getProducts = () => http.get("/products").then((r) => r.data);
export const getResources = () => http.get("/resources").then((r) => r.data);
export const getGuests = () => http.get("/guests").then((r) => r.data);
export const getEvents = () => http.get("/events").then((r) => r.data);
export const downloadUrl = (id) => `${API}/downloads/${id}`;

// ---- Admin ----
export const getLeadsSummary = () => http.get("/admin/leads-summary").then((r) => r.data);
export const getLeads = (collection) => http.get(`/admin/leads/${collection}`).then((r) => r.data);

// ---- Lead capture (POST) ----
export const subscribe = (email) => http.post("/subscribe", { email }).then((r) => r.data);
export const createInquiry = (payload) => http.post("/inquiries", payload).then((r) => r.data);
export const createSpeakerInquiry = (payload) => http.post("/speaker-inquiries", payload).then((r) => r.data);
export const createMembership = (payload) => http.post("/memberships", payload).then((r) => r.data);
export const resourceUnlock = (email) => http.post("/resource-unlock", { email }).then((r) => r.data);
export const submitQuizResult = (payload) => http.post("/quiz-results", payload).then((r) => r.data);

export default http;
